export const idlFactory = ({ IDL }) => {
  const CollateralType = IDL.Variant({
    'ICP' : IDL.Null,
    'ckBTC' : IDL.Null,
    'ckETH' : IDL.Null,
  });
  const AgentAction = IDL.Variant({
    'Withdraw' : IDL.Record({
      'coll' : CollateralType,
      'amountE8' : IDL.Nat,
      'vaultId' : IDL.Nat,
    }),
    'Mint' : IDL.Record({ 'amountE8' : IDL.Nat, 'vaultId' : IDL.Nat }),
    'Deposit' : IDL.Record({
      'coll' : CollateralType,
      'amountE8' : IDL.Nat,
      'vaultId' : IDL.Nat,
    }),
    'CreateVault' : IDL.Null,
    'Repay' : IDL.Record({ 'amountE8' : IDL.Nat, 'vaultId' : IDL.Nat }),
    'SwapUsdmForAsset' : IDL.Record({
      'asset' : CollateralType,
      'usdmInE8' : IDL.Nat,
    }),
    'SwapAssetForUsdm' : IDL.Record({
      'asset' : CollateralType,
      'assetInE8' : IDL.Nat,
    }),
    'Liquidate' : IDL.Record({ 'vaultId' : IDL.Nat, 'repayE8' : IDL.Nat }),
  });
  const GatewayError = IDL.Variant({
    'NotRegistered' : IDL.Null,
    'Paused' : IDL.Null,
    'InsufficientCredits' : IDL.Record({
      'available' : IDL.Nat,
      'required' : IDL.Nat,
    }),
    'InsufficientCycles' : IDL.Record({
      'required' : IDL.Nat,
      'accepted' : IDL.Nat,
    }),
    'RateLimit' : IDL.Text,
    'Unauthorized' : IDL.Text,
    'ScopeDenied' : IDL.Text,
    'Ledger' : IDL.Text,
    'Protocol' : IDL.Text,
    'Config' : IDL.Text,
  });
  const GatewayResult_3 = IDL.Variant({
    'ok' : IDL.Text,
    'err' : GatewayError,
  });
  const GatewayResult = IDL.Variant({ 'ok' : IDL.Null, 'err' : GatewayError });
  const GatewayResult_2 = IDL.Variant({ 'ok' : IDL.Nat, 'err' : GatewayError });
  const LiquidationPreview = IDL.Record({
    'maxRepayE8' : IDL.Nat,
    'auctionId' : IDL.Opt(IDL.Nat),
    'debtE8' : IDL.Nat,
    'currentAuctionPriceE8' : IDL.Opt(IDL.Nat),
    'bonusBps' : IDL.Nat,
    'estimatedBonusE8' : IDL.Nat,
    'vaultId' : IDL.Nat,
    'commissionE8' : IDL.Nat,
    'seizedCollateral' : IDL.Vec(IDL.Tuple(CollateralType, IDL.Nat)),
    'collateralValueE8' : IDL.Nat,
  });
  const GatewayResult_4 = IDL.Variant({
    'ok' : LiquidationPreview,
    'err' : GatewayError,
  });
  const MmkBookSide = IDL.Variant({
    'BuyMmk' : IDL.Null,
    'SellMmk' : IDL.Null,
  });
  const AgentScope = IDL.Variant({
    'All' : IDL.Null,
    'Read' : IDL.Null,
    'MmkBook' : IDL.Null,
    'Liquidate' : IDL.Null,
    'VaultWrite' : IDL.Null,
  });
  const AgentRecord = IDL.Record({
    'principal' : IDL.Principal,
    'active' : IDL.Bool,
    'dailyLiqs' : IDL.Nat,
    'dailyCalls' : IDL.Nat,
    'scopes' : IDL.Vec(AgentScope),
    'name' : IDL.Text,
    'createdAt' : IDL.Int,
    'dailyVaultCreates' : IDL.Nat,
    'icpDepositedE8' : IDL.Nat,
    'dailyDay' : IDL.Nat,
  });
  const FullConfig = IDL.Record({
    'maxDailyVaultCreates' : IDL.Nat,
    'maxInFlight' : IDL.Nat,
    'maxDailyCalls' : IDL.Nat,
    'registrationIcpE8' : IDL.Nat,
    'maxCallsPerMinute' : IDL.Nat,
    'minUserAgentIcpE8' : IDL.Nat,
    'liqCommissionBps' : IDL.Nat,
    'privilegedCycleFee' : IDL.Nat,
    'maxDailyLiqs' : IDL.Nat,
    'humanWaiverDailyMax' : IDL.Nat,
    'paused' : IDL.Bool,
    'maxLiqsPerMinute' : IDL.Nat,
  });
  const HuntCombo = IDL.Variant({
    'IcpBtc' : IDL.Null,
    'EthBtc' : IDL.Null,
    'IcpBtcEth' : IDL.Null,
  });
  const HuntTarget = IDL.Variant({
    'Asset' : CollateralType,
    'Combo' : HuntCombo,
  });
  const AgentCallEvent = IDL.Record({
    'id' : IDL.Nat,
    'ok' : IDL.Bool,
    'ts' : IDL.Int,
    'method' : IDL.Text,
    'agent' : IDL.Principal,
    'detail' : IDL.Text,
    'cyclesCharged' : IDL.Nat,
  });
  const AgentTxEvent = IDL.Record({
    'id' : IDL.Nat,
    'ts' : IDL.Int,
    'agent' : IDL.Principal,
    'kind' : IDL.Text,
    'detail' : IDL.Text,
    'vaultId' : IDL.Opt(IDL.Nat),
    'usdmSpentE8' : IDL.Nat,
  });
  const Stats = IDL.Record({
    'protocolSet' : IDL.Bool,
    'maxInFlight' : IDL.Nat,
    'registrationIcpE8' : IDL.Nat,
    'agentCount' : IDL.Nat,
    'totalHumanWaiverCalls' : IDL.Nat,
    'cycleOpsBalance' : IDL.Nat,
    'maxCallsPerMinute' : IDL.Nat,
    'minUserAgentIcpE8' : IDL.Nat,
    'blockedApiKeyCount' : IDL.Nat,
    'liqCommissionBps' : IDL.Nat,
    'activeCount' : IDL.Nat,
    'totalPaidCalls' : IDL.Nat,
    'treasuryIcpE8' : IDL.Nat,
    'privilegedCycleFee' : IDL.Nat,
    'humanWaiverDailyMax' : IDL.Nat,
    'paused' : IDL.Bool,
    'blockedPrincipalCount' : IDL.Nat,
    'maxLiqsPerMinute' : IDL.Nat,
  });
  const ApiKeyMeta = IDL.Record({
    'id' : IDL.Nat,
    'agent' : IDL.Principal,
    'revoked' : IDL.Bool,
    'createdAt' : IDL.Int,
    'keyLabel' : IDL.Text,
  });
  const GatewayResult_1 = IDL.Variant({
    'ok' : IDL.Principal,
    'err' : GatewayError,
  });
  return IDL.Service({
    'adminCreditIcp' : IDL.Func([IDL.Nat], [], []),
    'adminGrantCredits' : IDL.Func([IDL.Principal, IDL.Nat], [], []),
    'agentCallWithKey' : IDL.Func(
        [IDL.Text, AgentAction],
        [GatewayResult_3],
        [],
      ),
    'agentCancelOrder' : IDL.Func([IDL.Nat], [GatewayResult], []),
    'agentCreateVault' : IDL.Func([], [GatewayResult_2], []),
    'agentDepositCollateral' : IDL.Func(
        [IDL.Nat, CollateralType, IDL.Nat],
        [GatewayResult],
        [],
      ),
    'agentFillLiquidationAuction' : IDL.Func([IDL.Nat], [GatewayResult_4], []),
    'agentLiquidateVault' : IDL.Func([IDL.Nat], [GatewayResult_4], []),
    'agentLiquidateVaultAmount' : IDL.Func(
        [IDL.Nat, IDL.Nat],
        [GatewayResult_4],
        [],
      ),
    'agentMintUSDM' : IDL.Func([IDL.Nat, IDL.Nat], [GatewayResult], []),
    'agentPlaceLimit' : IDL.Func(
        [MmkBookSide, IDL.Nat, IDL.Nat],
        [GatewayResult_2],
        [],
      ),
    'agentRepayUSDM' : IDL.Func([IDL.Nat, IDL.Nat], [GatewayResult], []),
    'agentWithdrawCollateral' : IDL.Func(
        [IDL.Nat, CollateralType, IDL.Nat],
        [GatewayResult],
        [],
      ),
    'blockApiKey' : IDL.Func([IDL.Nat], [], []),
    'blockPrincipal' : IDL.Func([IDL.Principal], [], []),
    'buyCycleCreditsWithIcp' : IDL.Func([IDL.Nat], [GatewayResult_2], []),
    'createApiKey' : IDL.Func([IDL.Text], [GatewayResult_3], []),
    'depositCycleCredits' : IDL.Func([], [GatewayResult_2], []),
    'getAgent' : IDL.Func([IDL.Principal], [IDL.Opt(AgentRecord)], ['query']),
    'getCollWatchlist' : IDL.Func(
        [IDL.Principal],
        [IDL.Vec(CollateralType)],
        ['query'],
      ),
    'getConfig' : IDL.Func([], [FullConfig], ['query']),
    'getCycleCredits' : IDL.Func([IDL.Principal], [IDL.Nat], ['query']),
    'getCyclesCreditsPerIcpE8' : IDL.Func([], [IDL.Nat], ['query']),
    'getHuntHfRange' : IDL.Func(
        [IDL.Principal],
        [IDL.Record({ 'maxE8' : IDL.Nat, 'minE8' : IDL.Nat })],
        ['query'],
      ),
    'getHuntTargets' : IDL.Func(
        [IDL.Principal],
        [IDL.Vec(HuntTarget)],
        ['query'],
      ),
    'getMmkBook' : IDL.Func([], [IDL.Opt(IDL.Principal)], ['query']),
    'getMyCallHistory' : IDL.Func(
        [IDL.Nat, IDL.Nat],
        [IDL.Record({ 'total' : IDL.Nat, 'events' : IDL.Vec(AgentCallEvent) })],
        ['query'],
      ),
    'getMyCollWatchlist' : IDL.Func([], [IDL.Vec(CollateralType)], ['query']),
    'getMyHuntHfRange' : IDL.Func(
        [],
        [IDL.Record({ 'maxE8' : IDL.Nat, 'minE8' : IDL.Nat })],
        ['query'],
      ),
    'getMyHuntTargets' : IDL.Func([], [IDL.Vec(HuntTarget)], ['query']),
    'getMyTxHistory' : IDL.Func(
        [IDL.Nat, IDL.Nat],
        [IDL.Record({ 'total' : IDL.Nat, 'events' : IDL.Vec(AgentTxEvent) })],
        ['query'],
      ),
    'getProtocol' : IDL.Func([], [IDL.Opt(IDL.Principal)], ['query']),
    'getStats' : IDL.Func([], [Stats], ['query']),
    'health' : IDL.Func(
        [],
        [
          IDL.Record({
            'status' : IDL.Text,
            'protocolSet' : IDL.Bool,
            'agentCount' : IDL.Nat,
            'paused' : IDL.Bool,
          }),
        ],
        ['query'],
      ),
    'initAdmin' : IDL.Func([], [], []),
    'listApiKeyMeta' : IDL.Func([], [IDL.Vec(ApiKeyMeta)], ['query']),
    'listBlockedApiKeys' : IDL.Func([], [IDL.Vec(IDL.Nat)], ['query']),
    'listBlockedPrincipals' : IDL.Func([], [IDL.Vec(IDL.Principal)], ['query']),
    'myCycleCredits' : IDL.Func([], [IDL.Nat], ['query']),
    'myHumanWaiversRemaining' : IDL.Func([], [IDL.Nat], ['query']),
    'pause' : IDL.Func([IDL.Bool], [], []),
    'registerAgent' : IDL.Func(
        [IDL.Text, IDL.Vec(AgentScope)],
        [GatewayResult_1],
        [],
      ),
    'registerAgentAsHuman' : IDL.Func(
        [IDL.Text, IDL.Vec(AgentScope)],
        [GatewayResult_1],
        [],
      ),
    'revokeApiKey' : IDL.Func([IDL.Nat], [GatewayResult], []),
    'setAgentActive' : IDL.Func([IDL.Bool], [GatewayResult], []),
    'setConfig' : IDL.Func([FullConfig], [], []),
    'setCyclesCreditsPerIcpE8' : IDL.Func([IDL.Nat], [], []),
    'setIcpLedger' : IDL.Func([IDL.Principal], [], []),
    'setMmkBook' : IDL.Func([IDL.Principal], [], []),
    'setMyCollWatchlist' : IDL.Func(
        [IDL.Vec(CollateralType)],
        [GatewayResult],
        [],
      ),
    'setMyHuntHfRange' : IDL.Func([IDL.Nat, IDL.Nat], [GatewayResult], []),
    'setMyHuntTargets' : IDL.Func([IDL.Vec(HuntTarget)], [GatewayResult], []),
    'setProtocol' : IDL.Func([IDL.Principal], [], []),
    'unblockApiKey' : IDL.Func([IDL.Nat], [], []),
    'unblockPrincipal' : IDL.Func([IDL.Principal], [], []),
  });
};
export const init = ({ IDL }) => { return []; };